export default __webpack_public_path__ + "static/media/avatarA4.03c00a53.png";